<aside class="address-group">
  <div class="address-header">
    <input class="kyloe-checkbox" type="checkbox" [formControl]="selectAllCheckbox">
    <h3>Select fields to modify</h3>
  </div>
  <section [formGroup]="addressForm">
    <!-- TODO: Are there certain fields that should be required?-->
    <!-- TODO: Child component for these LI's -->
      <ul>
        <li class="address-action address-address1 big-input-grid-with grid-address-field-with-info"
            [ngClass]="{'disabled' : address1ControlCheckbox.value === false}"
            [matTooltip]="address1ControlCheckbox.value === false ? 'Field currently disabled. Select to enable field to modify' : ''" matTooltipPosition="left">
          <input class="kyloe-checkbox" type="checkbox" [formControl]="address1ControlCheckbox" (change)="toggleDisabledInputs(address1Control, 'address1')">
          <app-address-field-action
            [fieldControl]="address1Control"
            [checkBoxControl]="address1ControlCheckbox"
            [fieldLabel]="'Address Line 1'"
            [iconName]="'home'"
            [actionType]="this.typeControl.value"
          ></app-address-field-action>
          <span *ngIf="address1ControlCheckbox.value && tooltipNeeded" class="material-icons notranslate address-tooltip-icon danger"
                matTooltip="Note: Depending on the max length of the field, length of the current string and the length of the string to be {{this.actionDescriptor}}, the result string may be truncated."
                matTooltipClass="mat-tooltip">error_outline</span>
        </li>
        <li class="address-action address-address2 big-input-grid-with grid-address-field-with-info"
            [ngClass]="{'disabled' : address2ControlCheckbox.value === false}"
            [matTooltip]="address2ControlCheckbox.value === false ? 'Field currently disabled. Select to enable field to modify' : ''" matTooltipPosition="left">
          <input class="kyloe-checkbox" type="checkbox" [formControl]="address2ControlCheckbox" (change)="toggleDisabledInputs(address2Control, 'address2')">
          <app-address-field-action
            [fieldControl]="address2Control"
            [checkBoxControl]="address2ControlCheckbox"
            [fieldLabel]="'Address Line 2'"
            [iconName]="'home'"
            [actionType]="this.typeControl.value"
          ></app-address-field-action>
          <span *ngIf="address2ControlCheckbox.value && tooltipNeeded" class="material-icons notranslate address-tooltip-icon danger"
                matTooltip="Note: Depending on the max length of the field, length of the current string and the length of the string to be {{this.actionDescriptor}}, the result string may be truncated."
                 matTooltipClass="mat-tooltip">error_outline</span>
        </li>
        <li class="address-action address-city big-input-grid-with grid-address-field-with-info"
            [ngClass]="{'disabled' : cityControlCheckbox.value === false}"
            [matTooltip]="cityControlCheckbox.value === false ? 'Field currently disabled. Select to enable field to modify' : ''" matTooltipPosition="left">
          <input class="kyloe-checkbox" type="checkbox" [formControl]="cityControlCheckbox" (change)="toggleDisabledInputs(cityControl, 'city')">
          <app-address-field-action
            [fieldControl]="cityControl"
            [checkBoxControl]="cityControlCheckbox"
            [fieldLabel]="'City'"
            [iconName]="'location_city'"
            [actionType]="this.typeControl.value"
          ></app-address-field-action>
          <span *ngIf="cityControlCheckbox.value && tooltipNeeded" class="material-icons notranslate address-tooltip-icon danger"
                matTooltip="Note: Depending on the max length of the field, length of the current string and the length of the string to be {{this.actionDescriptor}}, the result string may be truncated."
                matTooltipClass="mat-tooltip">error_outline</span>
        </li>
        <li class="address-action address-state big-input-grid-with grid-address-field-with-info"
            [ngClass]="{'disabled' : stateControlCheckbox.value === false}"
            [matTooltip]="stateControlCheckbox.value === false ? 'Field currently disabled. Select to enable field to modify' : ''" matTooltipPosition="left">
          <input class="kyloe-checkbox" type="checkbox" [formControl]="stateControlCheckbox" (change)="toggleDisabledInputs(stateControl, 'state')">
          <app-address-field-action
            [fieldControl]="stateControl"
            [checkBoxControl]="stateControlCheckbox"
            [fieldLabel]="'State'"
            [iconName]="'home'"
            [actionType]="this.typeControl.value"
          ></app-address-field-action>
          <span *ngIf="stateControlCheckbox.value && tooltipNeeded" class="material-icons notranslate address-tooltip-icon danger"
                matTooltip="Note: Depending on the max length of the field, length of the current string and the length of the string to be {{this.actionDescriptor}}, the result string may be truncated."
                matTooltipClass="mat-tooltip">error_outline</span>
        </li>
        <li class="address-action address-zip big-input-grid-with grid-address-field-with-info"
            [ngClass]="{'disabled' : zipControlCheckbox.value === false}"
            [matTooltip]="zipControlCheckbox.value === false ? 'Field currently disabled. Select to enable field to modify' : ''" matTooltipPosition="left">
          <input class="kyloe-checkbox" type="checkbox" [formControl]="zipControlCheckbox" (change)="toggleDisabledInputs(zipControl, 'zip')">
          <app-address-field-action
            [fieldControl]="zipControl"
            [checkBoxControl]="zipControlCheckbox"
            [fieldLabel]="'Zip'"
            [iconName]="'home'"
            [actionType]="this.typeControl.value"
          ></app-address-field-action>
          <span *ngIf="zipControlCheckbox.value && tooltipNeeded" class="material-icons notranslate address-tooltip-icon danger"
                matTooltip="Note: Depending on the max length of the field, length of the current string and the length of the string to be {{this.actionDescriptor}}, the result string may be truncated."
                matTooltipClass="mat-tooltip">error_outline</span>
        </li>
        <li class="address-action address-country big-input-grid-with"
            [ngClass]="{'disabled' : countryControlCheckbox.value === false}"
            [matTooltip]="countryControlCheckbox.value === false ? countryTooltipMessage : ''" matTooltipPosition="left">
          <input class="kyloe-checkbox" type="checkbox" [formControl]="countryControlCheckbox"
                 (change)="toggleDisabledInputs(countryControl, 'countryID')">
          <app-address-country-field
            [countryControl]="countryControl"
            [inputCleared]="inputCleared"
          ></app-address-country-field>
        </li>
      </ul>
  </section>
</aside>
<!--{{addressForm.value | json}} | valid={{addressForm.valid}}, dirty={{addressForm.dirty}}-->
<!--<br>-->
<!--{{formGroup.value | json}} | valid={{formGroup.valid}}, dirty={{formGroup.dirty}}-->
